export const AddressFormResetValues = {
  address: {
    address: "",
    streetName: "",
    streetNumber: "",
    city: "",
    postalCode: "",
    country: "",
    region: "",
    regionShortName: "",
    countryLongName: "",
    provinceShortName: "",
    province: "",
    latitude: "",
    longitude: "",
  },
  complementAddress: {
    floorNumber: "",
    doorNumber: "",
    building: "",
  },
};
